var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg04Restaurant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8965,
    cy: 20.959,
    r: 20,
    fill: "#E7E6F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9141,
    cy: 20.959,
    r: 17,
    fill: "#4841A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9141,
    cy: 20.9766,
    r: 16,
    fill: "#8F87F3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8965,
    cy: 20.9766,
    r: 14,
    fill: "#4841A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9775 15.5189C15.2537 15.0406 15.8653 14.8767 16.3436 15.1528C16.8219 15.429 16.9857 16.0406 16.7096 16.5189L15.4596 18.6839C15.3215 18.9231 15.4035 19.2289 15.6426 19.3669C15.8817 19.505 16.1875 19.4231 16.3256 19.1839L17.5756 17.0189C17.8518 16.5406 18.4633 16.3767 18.9416 16.6528C19.4199 16.929 19.5838 17.5406 19.3077 18.0189L18.0577 20.1839C17.9196 20.4231 18.0015 20.7289 18.2407 20.8669C18.4798 21.005 18.7856 20.9231 18.9237 20.6839L20.1737 18.5189C20.4498 18.0406 21.0614 17.8767 21.5397 18.1528C22.018 18.429 22.1819 19.0406 21.9057 19.5189L20.4057 22.1169L19.4057 23.849C18.4735 25.4637 16.5854 26.1826 14.8687 25.7034L11.2923 31.898L9.56363 30.8999L13.1401 24.7054C11.8668 23.4583 11.5453 21.4637 12.4775 19.849L13.4775 18.1169L14.9775 15.5189Z",
    fill: "#353071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1113 15.0189C14.3875 14.5406 14.9991 14.3767 15.4774 14.6528C15.9556 14.929 16.1195 15.5406 15.8434 16.0189L14.5934 18.1839C14.4553 18.4231 14.5372 18.7289 14.7764 18.8669C15.0155 19.005 15.3213 18.9231 15.4594 18.6839L16.7094 16.5189C16.9855 16.0406 17.5971 15.8767 18.0754 16.1528C18.5537 16.429 18.7176 17.0406 18.4415 17.5189L17.1915 19.6839C17.0534 19.9231 17.1353 20.2289 17.3745 20.3669C17.6136 20.505 17.9194 20.4231 18.0575 20.1839L19.3075 18.0189C19.5836 17.5406 20.1952 17.3767 20.6735 17.6528C21.1518 17.929 21.3157 18.5406 21.0395 19.0189L19.5395 21.6169L18.5395 23.349C17.6073 24.9637 15.7192 25.6826 14.0025 25.2034L10.4261 31.398L8.69742 30.3999L12.2739 24.2054C11.0006 22.9583 10.6791 20.9637 11.6113 19.349L12.6113 17.6169L14.1113 15.0189Z",
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8073 22.349L17.2545 21.5744C17.3926 21.3352 17.6984 21.2533 17.9375 21.3914C18.1767 21.5294 18.2586 21.8352 18.1205 22.0744L17.6733 22.849C16.9297 24.137 15.3752 24.6649 14.027 24.1604C13.7684 24.0636 13.6872 23.7532 13.8252 23.514C13.9633 23.2749 14.2689 23.2003 14.5347 23.2751C15.3941 23.5169 16.3404 23.1576 16.8073 22.349Z",
    fill: "#ABA9C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.6958,
    y: 30.3989,
    width: 4,
    height: 6,
    rx: 1,
    transform: "rotate(30 8.6958 30.3989)",
    fill: "#353071"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.82959,
    y: 29.8989,
    width: 4,
    height: 6,
    rx: 1,
    transform: "rotate(30 7.82959 29.8989)",
    fill: "#8F87F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.016 19.7317C20.9551 20.6771 21.1753 21.6194 21.649 22.4398L22.4225 23.7797C23.3548 25.3944 25.2429 26.1133 26.9595 25.6341L30.536 31.8287L32.2646 30.8306L28.6882 24.6361C29.9615 23.389 30.283 21.3944 29.3507 19.7797L28.5772 18.4398C28.1035 17.6194 27.3976 16.9575 26.5484 16.5377C24.0928 15.3235 21.1923 16.9981 21.016 19.7317Z",
    fill: "#353071"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8822 19.2317C21.8213 20.1771 22.0415 21.1194 22.5152 21.9398L23.2887 23.2797C24.221 24.8944 26.1091 25.6133 27.8257 25.1341L31.4022 31.3287L33.1308 30.3306L29.5544 24.1361C30.8277 22.889 31.1492 20.8944 30.2169 19.2797L29.4434 17.9398C28.9697 17.1194 28.2638 16.4575 27.4146 16.0377C24.959 14.8235 22.0585 16.4981 21.8822 19.2317Z",
    fill: "#E7E6F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4845 20.2794L28.0372 19.5048C27.8992 19.2656 27.9811 18.9598 28.2202 18.8218C28.4594 18.6837 28.7652 18.7656 28.9033 19.0048L29.3505 19.7794C30.0941 21.0674 29.7741 22.6776 28.663 23.5929C28.4499 23.7685 28.1405 23.6836 28.0024 23.4445C27.8643 23.2053 27.9525 22.9033 28.1502 22.7105C28.7893 22.0872 28.9513 21.088 28.4845 20.2794Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.668,
    y: 32.3293,
    width: 4,
    height: 6,
    rx: 1,
    transform: "rotate(-30 29.668 32.3293)",
    fill: "#353071"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5342,
    y: 31.8293,
    width: 4,
    height: 6,
    rx: 1,
    transform: "rotate(-30 30.5342 31.8293)",
    fill: "#8F87F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Restaurant);
export default __webpack_public_path__ + "static/media/04_restaurant.6bc9b14c62cad62fa9729c97232fd341.svg";
export { ForwardRef as ReactComponent };